import Dashboard from "./components/Dashboard";
import "./css/App.css";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div>
      <Dashboard />
    </div>
  );
}

export default App;
